export interface HeroSlide {
  id: string;
  titleId: string;
  tagline: string;
  backdrop: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    titleId: "m-02",
    tagline: "穿越星海，为爱回航",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20space%20scene%20of%20an%20astronaut%20drifting%20before%20a%20giant%20ringed%20planet%20and%20a%20swirling%20wormhole%2C%20deep%20blue%20cosmos%20with%20warm%20amber%20rim%20light%2C%20cinematic%20wide%20shot%2C%20film%20grain&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "hero-2",
    titleId: "t-02",
    tagline: "凛冬将至，王座未定",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20wide%20shot%20of%20a%20dark%20stone%20castle%20hall%20with%20a%20glowing%20throne%20and%20drifting%20snow%20through%20broken%20windows%2C%20torchlight%20and%20cold%20blue%20tones%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "hero-3",
    titleId: "t-07",
    tagline: "末世之中，仍有人性微光",
    backdrop:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20wide%20shot%20of%20two%20figures%20walking%20through%20an%20overgrown%20abandoned%20city%20at%20dawn%2C%20fog%20and%20moss%20covered%20buildings%2C%20muted%20green%20and%20grey%20tones%2C%20cinematic%20still&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "hero-4",
    titleId: "m-10",
    tagline: "当正义被逼入黑暗",
    backdrop:
      "https://readdy.ai/api/search-image?query=dark%20gritty%20wide%20shot%20of%20a%20caped%20silhouette%20on%20a%20rainy%20skyscraper%20rooftop%20overlooking%20a%20glowing%20city%20at%20night%2C%20deep%20blue%20and%20black%20tones%2C%20dramatic%20cinematic&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
];